{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/NORTON",
	"name": "NORTON",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Echelle de Norton",
	"purpose": "Evaluation du risque d'escarres",
	"description": "Les patients qui ont un score en dessous de 14 sont à considérer comme à risque de développer un escarre de décubitus. Les auteurs (Norton, McLaren & ExtonSmith, 1962) vont plus loin dans leur interprétation et indiquent qu’un patient ayant un score en dessous de 12 est certain d’avoir des escarres.",
	"item": [
		{
			"linkId": "175",
			"text": "Condition physique",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "440",
						"display": "Très mauvaise"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "441",
						"display": "Pauvre"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "442",
						"display": "Moyenne"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "443",
						"display": "Bonne"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		},
		{
			"linkId": "177",
			"text": "Etat mental",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "444",
						"display": "Inconscient"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "445",
						"display": "Confus"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "446",
						"display": "Apathique"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "447",
						"display": "Bon, alerte"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		},
		{
			"linkId": "179",
			"text": "Activité",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "448",
						"display": "Totalement aidé"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "449",
						"display": "Assis"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "450",
						"display": "Marche avec une aide"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "451",
						"display": "Ambulatoire"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		},
		{
			"linkId": "181",
			"text": "Mobilité",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "452",
						"display": "Immobile"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "453",
						"display": "Très limitée"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "454",
						"display": "Diminuée"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "455",
						"display": "Totale"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		},
		{
			"linkId": "183",
			"text": "Incontinence",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-choiceOrientation",
					"valueCode": "horizontal"
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "456",
						"display": "Totale (urinaire et fécale)"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "457",
						"display": "Urinaire"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				},
				{
					"valueCoding": {
						"code": "458",
						"display": "Occasionnelle"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 3
						}
					]
				},
				{
					"valueCoding": {
						"code": "459",
						"display": "Aucune"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 4
						}
					]
				}
			]
		}
	]
}
